import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { InputErrorMessage as InputErrorMessageUnified } from './InputErrorMessage'
import { InputErrorMessageLegacy } from './InputErrorMessageLegacy'

interface InputErrorProps {
  errorElement: React.JSX.Element
  showIcon?: boolean
}

export const InputErrorMessage: React.FC<InputErrorProps> = props => {
  const isUnifiedEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR
  )

  return isUnifiedEnabled ? (
    <InputErrorMessageUnified {...props} />
  ) : (
    <InputErrorMessageLegacy errorElement={props.errorElement} />
  )
}
